<template>
    <div :class="loginScreenClass">
        <header class="" id="header-main" v-if="(user || ceremony) && !embed && $route.name !== 'welcome' && $route.name !== 'invite'">
            <nav class="navbar navbar-main navbar-expand-lg shadow navbar-light" id="navbar-main">
                <div class="container-fluid">
                    <button @click="showNavbar = !showNavbar"
                            class="navbar-toggler order-lg-2 ml-n3 ml-lg-0"
                            type="button"
                            data-toggle="collapse"
                            data-target="#navbar-main-collapse"
                            aria-controls="navbar-main-collapse"
                            aria-expanded="false"
                            aria-label="Toggle navigation"
                            :style="type === 'controller' ? { opacity: 0, pointerEvents: 'none' } : null"
                    >
                        <span class="navbar-toggler-icon"></span>
                    </button>

                    <router-link
                        class="navbar-brand order-lg-1"
                        :to="user && hasPermission('viewCeremonies') ? '/' : ''">
                        <img alt="Draaiboek" :src="!companyAssets ? require('../assets/lite/Logo.svg') : (companyAssets + '/logo.png')" id="navbar-logo" style="height: 50px !important">
                    </router-link>

                    <div class="collapse navbar-collapse navbar-collapse-overlay order-lg-3" id="navbar-main-collapse" :class="showNavbar ? 'show' : ''">

                        <div class="position-relative">
                            <button @click="showNavbar = !showNavbar" class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbar-main-collapse" aria-controls="navbar-main-collapse" aria-expanded="false" aria-label="Toggle navigation">
                                <XIcon />
                            </button>
                        </div>

                        <slot name="navigation" />

                        <ul class="navbar-nav align-items-lg-center d-none d-lg-flex" v-if="!user" :class="!ceremony ? 'ml-lg-auto' : ''">
                            <li class="nav-item dropdown dropdown-animate ml-4">
                                <LanguageSwitcher />
                            </li>
                        </ul>

                        <ul class="navbar-nav align-items-lg-center d-none d-lg-flex" v-if="user" :class="!ceremony ? 'ml-lg-auto' : ''" :style="ceremony ? 'margin-left: 20px' : ''">
                            <li class="nav-item dropdown dropdown-animate ml-5 mr-3" v-if="isLiteVersion">

                                <a
                                    class="btn btn-primary btn-sm d-flex align-items-center justify-content-center"
                                    href="#"
                                    role="button"
                                    v-tooltip="$t('theme.download_app_message')"
                                    @click="showDropdown($event, 'download')"
                                >
                                    <icon name="download" class="mr-2" />

                                    {{ $t('theme.download_app') }}
                                </a>

                                <div :class="visibleDropdown === 'download' ? 'show' : null" class="dropdown-menu dropdown-menu-sm dropdown-menu-right dropdown-menu-arrow p-3">
                                    <LiteDownloads />
                                </div>
                            </li>

                            <li class="nav-item dropdown dropdown-animate ml-3" style="margin-right: -25px;">
                                <LanguageSwitcher />
                            </li>

                            <UserNavigationItem v-if="user" :user="user" @logout="logout" class="ml-lg-5" />
                        </ul>

                    </div>
                </div>
            </nav>
        </header>

        <div class="container-fluid" :version="$root.version">
            <div class="row">
                <div class="col-12" :class="{ 'p-0': embed }">
                    <slot />
                </div>
            </div>
        </div>

        <div class="drienultwee-footer" v-if="ceremony && ceremony.company.footer_text && !embed">
            <div v-html="ceremony.company.footer_text"></div>
        </div>
    </div>
</template>

<script>

    import { mapGetters, mapState } from 'vuex';
    import { LogOutIcon, SearchIcon, SettingsIcon, UserIcon, XIcon } from 'vue-feather-icons';
    import LanguageSwitcher from '../components/LanguageSwitcher.vue';
    import LiteDownloads from '../components/LiteDownloads.vue';
    import { PLATFORMS } from '../enums/platforms';
    import UserNavigationItem from '../components/UserNavigationItem.vue';

    export default {

        components: {
            UserNavigationItem,
            LanguageSwitcher,
            XIcon,
            SearchIcon,
            SettingsIcon,
            UserIcon,
            LogOutIcon,
            LiteDownloads,
        },

        computed: {
            companyAssets() {
                return window.COMPANY_ASSETS;
            },

            showCreator() {
                return window.SHOW_CREATOR || false;
            },

            embed() {
                return window.location.search.includes('embed=true');
            },

            loginScreenClass() {
                if (this.$route.name === 'login' ||
                    this.$route.name === 'invite' ||
                    this.$route.name === 'code' ||
                    this.$route.name === 'register' ||
                    this.$route.name === 'welcome' ||
                    this.$route.name === 'forgot-password' ||
                    this.$route.name === 'resetpassword') {
                    return 'loginscreen';
                } else if (this.ceremony && this.ceremony.company.footer_text) {
                    return 'padding-bottom-40';
                }
            },

            isLiteVersion() {
                return !!window.IS_LITE_VERSION;
            },

            ...mapState({
                user: state => state.user,
                ceremony: state => state.ceremony,
            }),

            ...mapGetters([
                'hasPermission',
            ]),
        },

        props: {
            type: {
                type: String,
                required: true,
            },
        },

        data() {
            return {
                PLATFORMS,
                visibleDropdown: null,
                showNavbar: false,
            };
        },

        mounted() {
            document.addEventListener('click', this.documentClick);
        },

        beforeDestroy() {
            document.removeEventListener('click', this.documentClick);
        },

        methods: {
            logout() {
                this.$store.dispatch('logout');
                this.$router.push('/login');
            },

            documentClick() {
                this.visibleDropdown = null;
            },

            showDropdown($event, dropdown) {
                this.visibleDropdown = dropdown;
                $event.stopPropagation();
            },
        },
    };

</script>

<style lang="scss">

    body,
    html {
        overflow: initial;
    }


    .loginscreen {
        background-color: #2D2D2D;
        padding: 0;
        background-size: cover;
        background-position: 50%;
        /*overflow: ;*/
    }

    .drienultwee-footer {
        background: #ffffff;
        width: 100%;
        font-weight: 500;
        bottom: 0px;
        position: fixed;
        padding: 10px;
        text-align: center;
        border-top: 1px #ebebeb solid;
    }

    .drienultwee-footer a {
        color: #718096;
        text-decoration: underline;
    }

</style>
